import { render } from "./AppSelectItem.vue?vue&type=template&id=c8979a7a&scoped=true"
import script from "./AppSelectItem.vue?vue&type=script&lang=js"
export * from "./AppSelectItem.vue?vue&type=script&lang=js"

import "./AppSelectItem.vue?vue&type=style&index=0&id=c8979a7a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8979a7a"]])

export default __exports__